export default {
    id: 'orange-violet-blue',
    colors: ['#FC7E6A', '#6B32C9', '#8CCBFF'],
};
